(() => {
  const TOGGLE_SELECTOR = '.video-toggle';
  const CONTAINER_SELECTOR = '[data-video-toggle-container]';
  const USER_PAUSED_ATTR = 'data-user-paused';

  const updateToggleUI = (toggle, state) => {
    const isPlaying = state === 'playing';
    const playIcon = toggle.querySelector('[data-icon="play"]');
    const pauseIcon = toggle.querySelector('[data-icon="pause"]');
    const label = isPlaying ? toggle.dataset.labelPause : toggle.dataset.labelPlay;

    toggle.dataset.state = state;
    toggle.setAttribute('aria-pressed', String(isPlaying));
    if (label) toggle.setAttribute('aria-label', label);
    if (playIcon) playIcon.hidden = isPlaying;
    if (pauseIcon) pauseIcon.hidden = !isPlaying;
  };

  const playMedia = (container) => {
    const deferred = container.querySelector('deferred-media');
    if (deferred && !deferred.getAttribute('loaded')) deferred.loadContent(false);
    container.querySelectorAll('video').forEach((video) => {
      video.muted = true;
      video.play().catch(() => {});
    });
  };

  const pauseMedia = (container) => {
    container.querySelectorAll('video').forEach((video) => video.pause());
  };

  const initToggle = (toggle, reducedMotion) => {
    const container = toggle.closest(CONTAINER_SELECTOR);
    if (!container) return;

    container.addEventListener('play', () => {
      container.removeAttribute(USER_PAUSED_ATTR);
      updateToggleUI(toggle, 'playing');
    }, true);
    container.addEventListener('pause', () => updateToggleUI(toggle, 'paused'), true);

    if (reducedMotion.matches) {
      container.setAttribute(USER_PAUSED_ATTR, '');
      updateToggleUI(toggle, 'paused');
      pauseMedia(container);
    }

    toggle.addEventListener('click', () => {
      const nextState = toggle.dataset.state === 'playing' ? 'paused' : 'playing';
      if (nextState === 'paused') {
        container.setAttribute(USER_PAUSED_ATTR, '');
        pauseMedia(container);
      } else {
        container.removeAttribute(USER_PAUSED_ATTR);
        playMedia(container);
      }
    });
  };

  const init = () => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.querySelectorAll(TOGGLE_SELECTOR).forEach((toggle) => initToggle(toggle, reducedMotion));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
